import * as React from 'react';
import * as moment from 'moment';
import { isEmpty } from 'lodash';
import Categories from '../../shared/categories';
import Loader from '../../shared/loader';
import formatCurrency from '../../services/format.currency';
import { searchExpenses } from '../../actions/expenses';
import { expenseAmount } from '../../services/expenses.service';
export class Expenses extends React.Component<
  { searchExpenses; accounts; deleteExpense; history; user },
  { loading; terms; year; month; edit; expenses; element }
> {
  private date: Date;

  constructor(props) {
    super(props);
    const { search } = props.location;
    if (search) {
      this.state = {
        terms: new URLSearchParams(search).get('q'),
        year: new URLSearchParams(search).get('year'),
        month: new URLSearchParams(search).get('month'),
        loading: true
      } as any;
      searchExpenses(this.state.terms, this.state.year, this.state.month).then(expenses =>
        this.setState({ expenses, loading: false })
      );
    }
    this.state = { ...this.state, expenses: [] };
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  async delete(id) {
    await this.props.deleteExpense(id);
    this.setState({ loading: true });
    await searchExpenses(this.state.terms, this.state.year, this.state.month).then(expenses =>
      this.setState({ expenses, loading: false })
    );
  }

  async handleKeyPress(e) {
    if (e.key === 'Enter') {
      if (e.target.value) {
        this.props.history.push('/search-expenses?q=' + this.state.terms);
      }
    }
  }

  handleChange(el) {
    return event => {
      this.setState({ [el]: event.target.value, [`${el}Set`]: true } as any);
    };
  }

  getSign({ type, category }) {
    switch (type) {
      case 'INCOME':
        return '';
      case 'OTHER':
        switch (category) {
          case 'withdrawal':
            return '-';
          case 'deposit':
            return '';
        }
      default:
        return '-';
    }
  }

  different(dateA, dateB) {
    return isEmpty(dateA) || isEmpty(dateB) || moment(dateA).format('D MMM') !== moment(dateB).format('D MMM');
  }

  differentYear(dateA, dateB) {
    return isEmpty(dateA) || isEmpty(dateB) || moment(dateA).format('YYYY') !== moment(dateB).format('YYYY');
  }

  render() {
    const { accounts, user } = this.props;
    const categories = Categories;
    if (this.state.edit) {
      this.props.history.push('/update-expense' + `?_id=${this.state.element._id}`);
    }
    return (
      <div className="expenses-container">
        <div>
          <div className="center-align">
            <h5>Expenses</h5>
          </div>
        </div>
        <div className="row">
          <div className="col s12">
            <div className="center-align">
              <input
                type="text"
                value={this.state.terms}
                onChange={this.handleChange('terms')}
                onKeyPress={this.handleKeyPress}
                placeholder="Search"
              />
            </div>
            {!this.state.loading && (
              <table className="highlight payments">
                <thead>
                  <tr>
                    <th />
                    <th>Category</th>
                    <th>Description</th>
                    <th className="hide-on-med-and-down">Account</th>
                    <th>Amount</th>
                    <th />
                  </tr>
                </thead>

                <tbody>
                  {this.state.expenses
                    .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
                    .map((e, i, a) => [
                      this.differentYear(e.date, a[i - 1] && a[i - 1].date) && (
                        <tr className="grey lighten-4">
                          <td colSpan={5} className="center-align">
                            <b>{moment(e.date).format('YYYY')}</b>
                          </td>
                        </tr>
                      ),
                      <tr key={i}>
                        <td className="hide-on-small-only" onClick={() => this.setState({ edit: true, element: e })}>
                          <b>
                            {this.different(e.date, a[i - 1] && a[i - 1].date) && moment(e.date).format('D ddd MMM')}
                          </b>
                        </td>
                        <td className="hide-on-med-and-up" onClick={() => this.setState({ edit: true, element: e })}>
                          <b>{this.different(e.date, a[i - 1] && a[i - 1].date) && moment(e.date).format('D MMM')}</b>
                        </td>
                        <td onClick={() => this.setState({ edit: true, element: e })}>
                          <i className="material-icons blue-text tiny">
                            {(categories[e.category] && categories[e.category].icon) || 'change_history'}
                          </i>{' '}
                          <span className="hide-on-small-only">
                            &nbsp; &nbsp;
                            {e.category}
                          </span>
                        </td>
                        <td onClick={() => this.setState({ edit: true, element: e })}>{e.description}</td>
                        <td className="hide-on-med-and-down"> {accounts[e.account] && accounts[e.account].name}</td>
                        <td onClick={() => this.setState({ edit: true, element: e })}>
                          <span>{this.getSign(e)}</span>
                          <span>{formatCurrency(e.value, user)}</span>
                        </td>
                        <td style={{ padding: 0 }}>
                          <a
                            className="waves-effect waves-light"
                            onClick={() => {
                              var result = confirm('Are you sure you want to delete it?');
                              if (result) this.delete(e._id);
                            }}
                          >
                            <i className="material-icons small red-text">delete</i>
                            &nbsp;
                          </a>
                        </td>
                      </tr>
                    ])}
                  <tr>
                    <td> Sum</td>
                    <td>
                      {' '}
                      {formatCurrency(
                        this.state.expenses.reduce((s, exp) => s + expenseAmount(exp), 0),
                        user
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            )}
            {this.state.loading && <Loader />}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/expenses/search-expenses/component.tsx